import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';

@Component({
	selector: 'app-dynamic-form-input-date',
	standalone: false,
	templateUrl: './dynamic-form-input-date.component.html',
	styleUrl: './dynamic-form-input-date.component.scss'
})
export class DynamicFormInputDateComponent {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	toControlKey = AbstractDynamicForm.toControlKey;

}
